import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

/**
 * This custom GTM event will substitute history change event for homepage. The martech team will listen this
 * event for the homepage instead of the history change.
 *
 * We noticed that GTM has a big customer experience impact for the homepage because we load many scripts before our code is rendered.
 *
 * This event must be present!
 */

// DO NOT REMOVE THIS FUNCTION!
export function createSendHomepageOpenedToGtm() {
    let isEventSent = false;

    return function sendHomepageOpenedToGtm() {
        if (isEventSent) {
            return;
        }

        AnalyticsSDK.getInstance()
            .log('homepage-opened');

        isEventSent = true;
    };
}
